import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const StepsList = styled.ol`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.black2};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;
